import { AthenaLogo } from "../../Icons/AthenaLogo";
import Typography from "../Typography/Typography";
import { Link } from "react-router-dom";

export default function LandingFooter() {
    const isMobile = window.innerWidth < 768;

    return (
        <div className="w-full flex flex-col gap-6 md:gap-12 border-t-2 border-gray-150 pb-6">
            <div className="flex flex-col md:flex-row items-start md:justify-between gap-6 md:gap-0 md:items-center w-full pt-6 px-5 md:px-[40px]">
                <img className={isMobile ? "h-8" : "h-12"} src="/assets/images/logo/lockup.svg" alt="Athena Lockup" />
                <div className="flex flex-col md:flex-row gap-1 md:gap-9">
                    <Link to="/">
                        <Typography size={isMobile ? 12 : 16} weight="md" align={isMobile ? "right" : "center"} width="w-full">
                            Home
                        </Typography>
                    </Link>
                    <Link to="/blog">
                        <Typography size={isMobile ? 12 : 16} weight="md" align={isMobile ? "right" : "center"} width="w-full">
                            Blog
                        </Typography>
                    </Link>
                    <Link to="/pricing">
                        <Typography size={isMobile ? 12 : 16} weight="md" align={isMobile ? "right" : "center"} width="w-full">
                            Prezzi
                        </Typography>
                    </Link>
                    <Link to="/legal/terms">
                        <Typography size={isMobile ? 12 : 16} weight="md" align={isMobile ? "right" : "center"} width="w-full">
                            Termini
                        </Typography>
                    </Link>
                    <Link to="mailto:hello.athena.info@gmail.com">
                        <Typography size={isMobile ? 12 : 16} weight="md" align={isMobile ? "right" : "center"} width="w-full">
                            Scrivici
                        </Typography>
                    </Link>
                </div>
            </div>
            <div className={`${isMobile ? "px-5" : "px-0"} flex md:justify-center`}>
            <Typography size={isMobile ? 12 : 16} weight="md" align={isMobile ? "left" : "center"}  color="gray-600">
                © Copyright 2025. Tutti i diritti riservati.
            </Typography>
            </div>
        </div>
    )
}